import { ArrowRight, Trophy, Users, Calendar, Award } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const stats = [
    { icon: Trophy, label: '3 направления', value: 'Геймдев, 3D моделирование, Геймдизайн' },
    { icon: Users, label: 'Участники', value: '14–17 лет' },
    { icon: Calendar, label: 'Даты', value: '31 октября – 8 декабря 2026' },
    { icon: Award, label: 'Призы', value: 'Гранты, стажировки' },
  ];

  return (
    <section
      className="relative overflow-hidden py-16 md:py-24"
      style={{
        backgroundImage: "url('/images/hero.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative z-10 container mx-auto px-4">
        {/* Текст прижат влево, чтобы основное изображение справа оставалось открытым */}
        <div className="max-w-3xl text-center md:text-left lg:max-w-2xl space-y-8">
          <div>
            <span className="inline-block px-4 py-2 bg-primary-100 text-primary-800 rounded-full text-sm font-semibold">
              Онлайн-чемпионат Югры
            </span>
            <h1 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white">
              Создай свою
              <span className="block text-primary-200">игру будущего</span>
            </h1>
            <p className="mt-6 text-lg text-gray-200 max-w-2xl mx-auto md:mx-0">
              ОЧКИ — это пространство для школьников и студентов, где ты можешь проявить
              свои таланты в креативных индустриях, получить экспертизу от профессионалов
              и выиграть крутые призы.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <Link
              to="/registration"
              className="btn-primary inline-flex items-center justify-center text-lg px-8 py-4"
            >
              Подать заявку
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
            <Link
              to="/about"
              className="btn-secondary inline-flex items-center justify-center text-lg px-8 py-4"
            >
              Узнать больше
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-8">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="flex items-center space-x-3 p-4 rounded-xl bg-white/10 backdrop-blur-md border border-white/20 shadow-lg text-left"
              >
                <div className="shrink-0 p-2 bg-white rounded-lg shadow-sm">
                  <stat.icon className="h-5 w-5 text-primary-600" />
                </div>
                <div className="min-w-0">
                  <p className="text-base md:text-lg font-bold text-white leading-snug">
                    {stat.value}
                  </p>
                  <p className="text-sm text-gray-200">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}